import { Document, Font, Page, PDFViewer, StyleSheet } from '@react-pdf/renderer';
import { Header } from 'app/components/panels/inp/pdf/Header';
import { NetworkSummary } from 'app/components/panels/inp/pdf/NetworkSummary';
import { Footer } from 'app/components/panels/inp/pdf/Footer';
import React, { PureComponent } from 'react';
import { ATFCMDetails } from 'app/components/panels/inp/pdf/ATFCMDetails';
import { Milex } from 'app/components/panels/inp/pdf/Milex';
import { Weather } from 'app/components/panels/inp/pdf/Weather';
import { InitialNetworkPlanDto } from 'app/model/SOL49';
import { NetworkMap } from 'app/components/panels/inp/pdf/NetworkMap';
import { NatTracksMap } from 'app/components/panels/inp/pdf/NatTracksMap';

Font.register({
    family: 'Roboto',
    fonts: [
        {
            src: 'https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Me5WZLCzYlKw.ttf',
        },
        {
            src: 'https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlvAx05IsDqlA.ttf',
            fontWeight: 'bold',
        },
    ],
});

export class PdfDocument extends PureComponent<{
    inp: InitialNetworkPlanDto;
    networkMapImg: string;
    natTracksImg: string;
}> {
    render() {
        return (
            <PDFViewer width={'100%'} height={'100%'}>
                <Document>
                    <Page style={styles.page}>
                        <Header />
                        <NetworkMap map={this.props.networkMapImg} date={this.props.inp.date} />
                        <Footer />
                    </Page>
                    <Page style={styles.page}>
                        <Header />
                        <NetworkSummary summary={this.props.inp.networkSummary} />
                        <Footer />
                    </Page>
                    <Page size="A4" style={styles.page}>
                        <Header />
                        <ATFCMDetails atfcmDetails={this.props.inp.atfcmDetails} />
                        <Footer />
                    </Page>
                    <Page size="A4" style={styles.page}>
                        <Header />
                        <Milex events={Object.values(this.props.inp.milex).map(milex => milex.event)} />
                        <Footer />
                    </Page>
                    <Page size="A4" style={styles.page}>
                        <Header />
                        <NatTracksMap natTracks={this.props.natTracksImg} />
                        <Footer />
                    </Page>
                    <Page size="A4" style={styles.page}>
                        <Header />
                        <Weather />
                        <Footer />
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}

export const styles = StyleSheet.create({
    page: {
        fontFamily: 'Roboto',
        fontSize: '12',
        paddingTop: 35,
        paddingBottom: 35,
        paddingHorizontal: 35,
    },
    section_title: {
        fontWeight: 'bold',
        fontSize: 25,
        padding: '10px',
    },
    h3_underlined: {
        textDecoration: 'underline',
        paddingBottom: '5px',
    },
    h2: {
        fontSize: 15,
        fontWeight: 'bold',
        padding: '5px 0',
    },
});
